"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Select = void 0;
const react_1 = __importStar(require("react"));
const ChevronDown_1 = require("../icons/ChevronDown/ChevronDown");
const Select_styled_1 = require("./Select.styled");
const Text_1 = require("../Typography/Text");
const Subtitle_1 = require("../Typography/Subtitle");
const Color_enum_1 = require("../../constants/Color.enum");
exports.Select = react_1.default.forwardRef(function Select({ items, renderOption = ({ value }) => react_1.default.createElement(Text_1.TextXS, { color: "inherit" }, value), renderValue = ({ value }) => `${value}`, onChange, onBlur, name, label, }, forwardedRef) {
    const selectRef = (0, react_1.useRef)(null);
    const selectContainerRef = (0, react_1.useRef)(null);
    const [open, setOpen] = (0, react_1.useState)(false);
    (0, react_1.useEffect)(() => {
        const handleClickOutside = (event) => {
            if (selectContainerRef.current && !selectContainerRef.current.contains(event.target)) {
                setOpen(false);
            }
        };
        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);
    return (react_1.default.createElement(Select_styled_1.SelectContainer, { open: open, ref: selectContainerRef },
        react_1.default.createElement(Select_styled_1.SelectWrapper, null,
            react_1.default.createElement("div", null,
                label && react_1.default.createElement(Subtitle_1.SubtitleXS, { color: Color_enum_1.Color.Secondary }, label),
                react_1.default.createElement(Select_styled_1.SelectWithHiddenArrow, { onClick: (e) => {
                        e.preventDefault();
                    }, onFocus: (e) => {
                        setOpen(true);
                        e.preventDefault();
                    }, ref: (elem) => {
                        selectRef.current = elem;
                        if (forwardedRef) {
                            if (typeof forwardedRef === 'function') {
                                forwardedRef(elem);
                            }
                            else {
                                forwardedRef.current = elem;
                            }
                        }
                    }, name: name, onChange: onChange, onBlur: onBlur }, items.map((item, index) => (react_1.default.createElement("option", { key: index, value: item.value }, renderValue(item)))))),
            react_1.default.createElement(ChevronDown_1.ChevronDownIcon, null)),
        open && (react_1.default.createElement(Select_styled_1.SelectStyled, null, items.map((item, index) => (react_1.default.createElement(Select_styled_1.SelectItemStyled, { key: index, onClick: () => {
                const select = selectRef.current;
                setOpen(false);
                if (select) {
                    select.value = item.value;
                    select.dispatchEvent(new Event('change', { bubbles: true }));
                }
            } }, renderOption(item))))))));
});
